/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { RequestTemplate } from '@src/app/model/RequestTemplate';
import { CommsTemplateType } from '@src/app/model/CommsTemplate';
import { uuid } from '@src/app/model/abstract-object';

@Injectable({
  providedIn: 'root'
})
export class CommsTemplateService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected get baseUrl() {
    return this.getAjaxPath('social/comms');
  }
  protected cache: RequestTemplate[];
  protected typeString = 'Communication Templates';
  /*
    getFileDownload(path, forceTeam: uuid = null, accepts = : Observable<HttpResponse<Blob>> {
        let params: Params = {};
        if (forceTeam) {
            params = { _forceTeam: forceTeam }
        }

    }  
*/

  previewPDF(type: CommsTemplateType, content: string) {
    const path = this.baseUrl + '/previewPDF';
    const data = {type, content};
    console.log(data);
    const options: {
      headers?: HttpHeaders | Record<string, string | string[]>,
      observe: 'response', // Tells Angular to return the full HttpResponse
      responseType: 'blob' // Tells Angular to interpret the body as a Blob
    } = {headers: { 'Accept': 'application/octet-stream'}, observe: 'response', responseType: 'blob' };
    
    return this.http.post(path, data, options).subscribe( x => {
      this.doResponseDownload(x);
    });
  }

  preview(type: string, content: string, sampleId: uuid, title: string, omcId?: uuid): Observable<{ html: string }> {
    const path = this.baseUrl + '/preview';
    return this.http.post<{ html: string }>(path, { type, content, sampleId, title }, this.getSimpleOptions(omcId)).pipe(
      catchError((error) => {
        this.messageService.showError(error, 'Previewing Template');
        return of(null);
      })
    );
  }

  sendTest(type: string, content: string, sampleId: uuid, title: string, omcId?: uuid): Observable<{ status: string }> {
    const path = this.baseUrl + '/sendTest';
    return this.http.post<{ status: string }>(path, { type, content, sampleId, title }, this.getSimpleOptions(omcId)).pipe(
      catchError((error) => {
        this.messageService.showError(error, 'Sending Test');
        return of(null);
      })
    );
  }

}
